import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';

/**
 * DELETE /api/eraf/codes/groups/{groupCode}/items/{itemCode} — 코드 항목 삭제
 * 성공 시 ['common-code', 'items', groupCode] 쿼리 무효화
 */
export function useDeleteCodeItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupCode, itemCode }: { groupCode: string; itemCode: string }) =>
      codeApi.deleteItem(groupCode, itemCode),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['common-code', 'items', variables.groupCode],
      });
      void queryClient.invalidateQueries({ queryKey: ['common-code', 'list'] });
    },
  });
}
